/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { CardWrapper, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      <Title secondary>
        Sobre os documentos
      </Title>
      <Text>
        Para entrar com o processo de Revisão do FGTS é necessário que você se identifique perante a Justiça, por este motivo listamos esta documentação para você iniciar o processo no site do Juizado Especial Federal, sem maiores dificuldades. Ainda tem dúvidas?
        {' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://ajuda.tikal.tech/pt-BR/articles/4848739-entrando-com-o-processo-no-juizado-especial-federal"
        >
          Clique aqui
        </a>
      </Text>
      <BoxButton>
        <Button onClick={() => {
          window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace('/', '')}`);
          window.Intercom('show');
          onClose(false);
        }}
        >
          Iniciar conversa com o suporte
        </Button>
      </BoxButton>
    </CardWrapper>
  );
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default HelpModal;
